var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"9ec96767e059d8d64d7e56b93e27b6d5977cdc79"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { extraErrorDataIntegration } from '@sentry/integrations'
import * as Sentry from '@sentry/nextjs'
import {
  SENTRY_ERROR_SAMPLE_RATE,
  SENTRY_REPLAY_SAMPLE_RATE,
  SENTRY_TRACE_SAMPLE_RATE,
} from '@/constants/config'

Sentry.init({
  debug: false,
  dsn: process.env.SENTRY_ENVIRONMENT ? process.env.SENTRY_DNS : undefined,
  environment: process.env.SENTRY_ENVIRONMENT,
  integrations: [
    new Sentry.Replay({
      maskAllText: true,
      blockAllMedia: true,
    }),
    new Sentry.BrowserTracing(),
    Object(extraErrorDataIntegration()),
  ],
  replaysSessionSampleRate: SENTRY_REPLAY_SAMPLE_RATE,
  replaysOnErrorSampleRate: SENTRY_ERROR_SAMPLE_RATE,
  sendDefaultPii: true,
  tracesSampleRate: SENTRY_TRACE_SAMPLE_RATE,
  ignoreTransactions: ['manifest'],
})
